module.exports = __webpack_public_path__ + "img/detail-quotation.56e2f187.svg";